
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GlobalMenu extends Vue {
  @Prop() public title!: string;

  public logout() {
    this.$api.auth.logout();
  }
}
